"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var linear_tween_1 = require("@opten/animation/linear-tween");
var scroll_to_offset_1 = require("../scroll-to-offset");
function scrollToElement(target, animation, duration, offset, wrapper) {
    if (animation === void 0) { animation = linear_tween_1.default; }
    if (duration === void 0) { duration = 300; }
    if (offset === void 0) { offset = 0; }
    if (wrapper === void 0) { wrapper = window; }
    var top = wrapper !== window
        ? target.offsetTop - wrapper.scrollTop
        : target.getBoundingClientRect().top;
    return scroll_to_offset_1.default(top, animation, duration, offset, wrapper);
}
exports.default = scrollToElement;
